import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-722ab14d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "affixBox" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-text" }, "回到顶部", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-text" }, "售前咨询", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "consultStrip-content" }
const _hoisted_8 = ["src"]

import { ref, onMounted, defineAsyncComponent } from 'vue';
import $bus from '@/utils/bus'
import { isElemVisible, throttle } from '@/utils/util'
// import consultPopup from './consult/consultPopup.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const consultPopup = defineAsyncComponent(() => import(/* webpackChunkName:"consultPopup.vue" */'./consult/consultPopup.vue'))
const isWorkday = ref(true) //是否工作日
const isShowPopup = ref(false) //咨询弹窗
const isMounted = ref(false)
const isShowStrip = ref(true) //悬浮条
const stripVisible = ref(false) //是否关闭悬浮条
const backTop = ref(false)

const date = new Date()
const noWorkday = [0, 1];//不是工作日
// 注：星期日为 0，星期一为 1，依此类推。
if (noWorkday.includes(date.getDay())) {
    isWorkday.value = false
}else if (!getIsWorkeTime(date)) {
    console.log('工作日----非工作时间')
    isWorkday.value = false
}

function getIsWorkeTime(time:Date):boolean {
    const timeStar = new Date(),timeEnd = new Date();
    timeStar.setHours(9)
    timeStar.setMinutes(30)
    timeEnd.setHours(20)
    timeEnd.setMinutes(30)
    const now = time.getTime();
    return now>timeStar.getTime() && now<timeEnd.getTime();
}

let header: HTMLElement;
onMounted(() => {
    header = document.getElementsByClassName('header')[0] as HTMLElement
    isMounted.value = true
    document.addEventListener('scroll', throttle(handleScroll))
    handleScroll()
})
function handleScroll() {
    if (isShowStrip.value) {
        if (!isElemVisible(header)) {
            stripVisible.value = true
        } else {
            stripVisible.value = false
        }
    }
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop >= 500) {
        backTop.value = true
    } else {
        backTop.value = false

    }
}
function closeConsultStrip() {
    isShowStrip.value = false
}
function showPopup(flag: boolean) {
    isShowPopup.value = flag
}
function onCackTop() {
    header.scrollIntoView({
        behavior: 'smooth'
    })
}
$bus.on('CONSULT_POPUP',showPopup)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["affixBox-item", { 'affix-fade-in-end': backTop.value }]),
        onClick: onCackTop
      }, [
        _createElementVNode("img", {
          class: "item-icon",
          src: require(`@/assets/images/backTop.png`)
        }, null, 8, _hoisted_2),
        _hoisted_3
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["affixBox-item affix-fade-in", { 'affix-fade-in-end': isMounted.value }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showPopup(true)))
      }, [
        _createElementVNode("img", {
          class: "item-icon",
          src: require(`@/assets/images/affix${isWorkday.value ? 1 : 2}.png`)
        }, null, 8, _hoisted_4),
        _hoisted_5
      ], 2)
    ]),
    (isShowStrip.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["consultStrip", { 'consultStrip-fade-in': stripVisible.value }])
        }, [
          _createElementVNode("img", {
            class: "consultStrip-close",
            src: require('@/assets/images/footer/close.png'),
            onClick: closeConsultStrip
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              class: "consultStrip-slogan",
              src: require('@/assets/images/slogan.png')
            }, null, 8, _hoisted_8),
            _createElementVNode("div", {
              class: "consultStrip-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showPopup(true)))
            }, "立即咨询")
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_unref(consultPopup), {
      modelValue: isShowPopup.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isShowPopup).value = $event)),
      isWorkday: isWorkday.value
    }, null, 8, ["modelValue", "isWorkday"])
  ], 64))
}
}

})